<p-accordion [(activeIndex)]="activeIndex"  (onOpen)="callEvent($event)">
    <!-- <p-accordionTab header="Preferred Vendor" [selected]="true">
      <p-table #db [value]="productBrands" [scrollable]="true" scrollHeight="180px"
        [reorderableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="max-width:3rem"></th>
            <th class="p-col-10" pReorderableColumn>Name</th>
            <th class="p-col-2" pReorderableColumn>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr [pReorderableRow]="index" style="cursor: move;">
            <td style="max-width:3rem">
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
            <td class="p-col-2 action" pReorderableRowHandle>
              <span class="btnBars p-mr-0" (click)="showEditProductData(data, 'vendor')"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="delLeadSource(data)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab> -->
    <p-accordionTab header="Brand">
      <p-table #db [value]="productBrands">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-10">Name</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-10">{{data.name}}</td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="showEditProductData(data, fieldDataConstants.brandFieldName)"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="checkDeleteStatus(data,fieldDataConstants.titleCasebrandFieldName)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
    <!-- <p-accordionTab header="Manufacturer">
      <p-table #db [value]="productManufacturers" [scrollable]="true" scrollHeight="180px"
        [reorderableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="max-width:3rem"></th>
            <th class="p-col-10" pReorderableColumn>Name</th>
            <th class="p-col-2" pReorderableColumn>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr [pReorderableRow]="index" style="cursor: move;">
            <td style="max-width:3rem">
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
            <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
            <td class="p-col-2 action" pReorderableRowHandle>
              <span class="btnBars p-mr-0" (click)="showEditProductData(data, 'manufacturer')"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" (click)="delete(data,'Manufacturer')" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab> -->
    <p-accordionTab header="Warranty">
      <p-table #db [value]="productWarranty">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-10">Name</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-10">{{data.name}}</td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="showEditProductData(data, fieldDataConstants.warrantyFieldName)"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="checkDeleteStatus(data,fieldDataConstants.titlewarrantyFieldName)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
    <p-accordionTab header="Color">
      <p-table #db [value]="productColor">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-5">Name</th>
            <th class="p-col-5">Is Active</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-5">{{data.name}}</td>
            <td class="p-col-5">{{data.statusId==1?'Yes':'No'}}</td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" *ngIf="data.createdSource!='system'" (click)="showEditProductData(data, fieldDataConstants.colorFieldName)"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" *ngIf="data.createdSource!='system'"  (click)="checkDeleteStatus(data,fieldDataConstants.colorFieldName)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
    <p-accordionTab header="Variant">
      <p-table #db [value]="variants">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-col-10">Name</th>
            <th class="p-col-2">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex">
          <tr>
            <td class="p-col-10">{{data.name}}</td>
            <td class="p-col-2 action">
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="showEditProductData(data, fieldDataConstants.variantFieldName)"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="checkDeleteStatus(data,fieldDataConstants.variantFieldName)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
  </p-accordion>

  <p-dialog header="{{addEditProductHeader}}" [modal]="true" [(visible)]="displayAddProductData"
    [style]="{width: '50vw'}" [baseZIndex]="10000" (onHide)="productAddFieldForm.reset();invalidData=false">
    <form [formGroup]="productAddFieldForm">
      <div class="p-grid">
        <div class="p-col-12" *ngIf="addEditProductHeader == fieldDataConstants.AddFiedTitle">
          <label for="type">Fields Type <span style="color: red;">*</span></label>
          <p-dropdown [options]="productDataTypes" formControlName="fieldType"
            optionLabel="name"  placeholder="Select Field Type" 
            (onChange)="getInventoryGroups(productAddFieldForm.controls['fieldType'].value?.code)"
            appendTo="body"></p-dropdown>
        </div>
        <div class="p-col-12" *ngIf="addEditProductHeader == fieldDataConstants.EditFieldTitle">
          <h5 class="p-mb-0">Fields Name -- {{productTypeName}}</h5>
        </div>
        <div class="p-col-12">
          <label for="name">Name <span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
          <!-- <small *ngIf="dataName.invalid && (dataName.touched ||
        dataName.dirty)" class="p-invalid">
            Name is required
          </small> -->
          <small *ngIf="invalidData == true" class="p-invalid">
            Name exists in the list already
          </small>
        </div>
        <div class="p-col-12">
          <label for="name">Description</label>
          <input type="text" formControlName="description" pInputText style="width: 100%;">
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button pButton (click)="displayAddProductData=false" label="Cancel" class="p-button-secondary"></button>
      <button pButton [disabled]="!productAddFieldForm.valid" (click)="saveProductDataAdd(productAddFieldForm.value)" label="Save"></button>
    </ng-template>
  </p-dialog>

  <p-dialog header="Delete field" [(visible)]="displayProductAvailability" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="header">
    <h5>Delete Warning</h5>
  </div>
  <div class="card">
    <span style="font-weight: bold;">This field is associated with below Multiple Products</span><br>
    <span>{{associatedProducts}}</span>
  </div>
</p-dialog>

  <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
